import PropTypes from 'prop-types';
import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { ChatConsumer, ChatProvider } from './context';
import { Chat } from './chatbot';

export const DialogChatbot = forwardRef(({type, config_data, headerText = "Template Chat", setTemplateCode, getTemplateCode, getSiteConfigData}, ref) => {

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [chatInitialized, setChatInitialized] = useState(false);

  useImperativeHandle(ref, () => ({
    showDialog: () => {
      setIsDialogOpen(true);
    },
  }));

  useEffect(() => {
    setChatInitialized(true);
  }, []);

  return (
    <>
      {/* ChatProvider is outside the Dialog to persist even when dialog is closed */}
      {chatInitialized && (
        <ChatProvider
          type_str={type}
          config_data={config_data}
          set_template_code={setTemplateCode}
          get_template_code={getTemplateCode}
          get_site_config_data={getSiteConfigData}
        >
          <Dialog 
            open={isDialogOpen} 
            onClose={() => setIsDialogOpen(false)}
            maxWidth="md"
            fullWidth
            keepMounted
            className="is-dialog-chat"
          >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {headerText}
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.8333 2.5H4.16663C3.50358 2.5 2.8677 2.76339 2.39886 3.23223C1.93002 3.70107 1.66663 4.33696 1.66663 5V17.5C1.66688 17.6477 1.70637 17.7926 1.78104 17.92C1.85572 18.0474 1.9629 18.1526 2.09163 18.225C2.21617 18.2956 2.3568 18.3329 2.49996 18.3333C2.64953 18.3333 2.79633 18.293 2.92496 18.2167L6.66663 15.95C6.80493 15.8677 6.96412 15.8271 7.12496 15.8333H15.8333C16.4963 15.8333 17.1322 15.5699 17.6011 15.1011C18.0699 14.6323 18.3333 13.9964 18.3333 13.3333V5C18.3333 4.33696 18.0699 3.70107 17.6011 3.23223C17.1322 2.76339 16.4963 2.5 15.8333 2.5ZM6.66663 10C6.50181 10 6.34069 9.95113 6.20365 9.85956C6.06661 9.76799 5.9598 9.63784 5.89673 9.48557C5.83365 9.3333 5.81715 9.16574 5.8493 9.00409C5.88146 8.84244 5.96083 8.69395 6.07737 8.57741C6.19391 8.46087 6.3424 8.3815 6.50405 8.34935C6.6657 8.31719 6.83326 8.33369 6.98553 8.39677C7.1378 8.45984 7.26795 8.56665 7.35952 8.70369C7.45109 8.84073 7.49996 9.00185 7.49996 9.16667C7.49996 9.38768 7.41216 9.59964 7.25588 9.75592C7.0996 9.9122 6.88764 10 6.66663 10ZM9.99996 10C9.83514 10 9.67402 9.95113 9.53698 9.85956C9.39994 9.76799 9.29313 9.63784 9.23006 9.48557C9.16699 9.3333 9.15048 9.16574 9.18264 9.00409C9.21479 8.84244 9.29416 8.69395 9.4107 8.57741C9.52725 8.46087 9.67573 8.3815 9.83738 8.34935C9.99903 8.31719 10.1666 8.33369 10.3189 8.39677C10.4711 8.45984 10.6013 8.56665 10.6929 8.70369C10.7844 8.84073 10.8333 9.00185 10.8333 9.16667C10.8333 9.38768 10.7455 9.59964 10.5892 9.75592C10.4329 9.9122 10.221 10 9.99996 10ZM13.3333 10C13.1685 10 13.0074 9.95113 12.8703 9.85956C12.7333 9.76799 12.6265 9.63784 12.5634 9.48557C12.5003 9.3333 12.4838 9.16574 12.516 9.00409C12.5481 8.84244 12.6275 8.69395 12.744 8.57741C12.8606 8.46087 13.0091 8.3815 13.1707 8.34935C13.3324 8.31719 13.4999 8.33369 13.6522 8.39677C13.8045 8.45984 13.9346 8.56665 14.0262 8.70369C14.1178 8.84073 14.1666 9.00185 14.1666 9.16667C14.1666 9.38768 14.0788 9.59964 13.9225 9.75592C13.7663 9.9122 13.5543 10 13.3333 10Z" fill="black"/>
              </svg>
            </DialogTitle>
            <DialogContent>
              <ChatConsumer>
                <Chat 
                  isMinimized={false} 
                  setIsMinimized={() => {}} 
                  showChatButton={false} 
                  headerText={headerText} 
                />
              </ChatConsumer>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setIsDialogOpen(false)}
                variant="outlined"
                color="primary"
              >
                閉じる
              </Button>
            </DialogActions>
          </Dialog>
        </ChatProvider>
      )}
    </>
  );
})

export default DialogChatbot;

DialogChatbot.propTypes = {
  type: PropTypes.string.isRequired,
  config_data: PropTypes.object,
  headerText: PropTypes.string,
  setTemplateCode: PropTypes.func,
  getTemplateCode: PropTypes.func,
  getSiteConfigData: PropTypes.func,
}
